import cookies from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import {
  initGA,
  updateSegmentConsentState,
} from '../../modules/analytics/analytics';
import { CookieManager } from '../../types/cookiehub';
import { initDatadogLogging, initDatadogRum } from '../../modules/monitoring';
import { trackingCookieNames } from '../../constants/cookie-consent';
import { getAnonymousUserId } from '../../libs/user-utils';

export const COOKIE_MANAGER: CookieManager = {
  analytics: {
    enable: ({ user }) => {
      initGA();
      updateSegmentConsentState();

      // Initialise Datadog logging & RUM
      const anonymousUserId = getAnonymousUserId();
      initDatadogLogging();
      initDatadogRum(user, anonymousUserId);
    },
    disable: () => {
      // Remove cookies by name
      Object.values(trackingCookieNames).forEach((cookieName) =>
        cookies.remove(cookieName)
      );

      updateSegmentConsentState();

      datadogRum.stopSession();
      datadogRum.stopSessionReplayRecording();
    },
  },
};
